import { Label, LookupModelSearchEvent, LookupModelSelectionEvent, TableRow, TableRowCreationEvent, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutLaneSendToContacts } from "./autogen/AutogenLayoutLaneSendToContacts";
import { ModelRow, StringUtil } from "@mcleod/core";

export class LaneSendToContacts extends AutogenLayoutLaneSendToContacts {
    private _payeeId: string;

    tableSendToContactsOnRowDisplay(event: TableRowDisplayEvent){
        const tableRow = event.getTableRow();
        const labelLaneCount = tableRow.findComponentById("labelLaneCount") as Label;
        if (this.tableSendToContacts.quickAddRow === tableRow) {
            if (labelLaneCount != null) {
                labelLaneCount.visible = false;
            }
        } else {
            const modelRow = tableRow.data as ModelRow;
            if (labelLaneCount != null && !modelRow.isNull('lane_number')) {
                const suffix = ' lane(s)';
                const laneNumberString = modelRow.getString('lane_number');
                if (StringUtil.equalsIgnoreCase("*", laneNumberString)) {
                    labelLaneCount.text = 'All'+ suffix;
                } else {
                    const laneNumbers = laneNumberString.split(',');
                    labelLaneCount.text = laneNumbers.length + suffix;
                }
            }
        }
    }

    tableSendToContactsOnRowCreate(event: TableRowCreationEvent){
        const tableRow: TableRow = event.target as TableRow;
        const modelRow: ModelRow = tableRow.data;
        if (modelRow._appending) {
            if (this.tableSendToContacts.quickAddRow === tableRow) {
                modelRow.set('sequence', 0);
            } else {
                modelRow.set('sendto_via', 'E');
                modelRow.set('lane_number', '*');
                const seq = this.tableSendToContacts.allRows
                    .map((row) => row.data?.getNumber("sequence", null))
                    .filter(seq => seq != null)
                    .reduce((a, b) => Math.max(a, b), 0);
                modelRow.set('sequence', seq ? seq + 1 : 1);
            }
        }
    }

    textboxSendtoNameBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.parent_row_type = "P";
        event.filter.parent_row_id = this.payeeId;
    }

    textboxSendtoNameOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection() === true) {
            const tableRow = TableRow.getContainingTableRow(event.target);
            if (tableRow != null) {
                const textboxSendtoDetail = tableRow.findComponentById("textboxSendtoDetail") as Textbox;
                if (textboxSendtoDetail != null) {
                    textboxSendtoDetail.text = event.selection.get("email");
                }
            }
        }
    }

    public get payeeId(): string {
        return this._payeeId;
    }

    public set payeeId(value: string) {
        this._payeeId = value;
    }
}
